export default {
  app_name: "V-IM",
  http_protocol: "https",
  http_port: "",
  // http_port: 8080,
  ws_port: 9326,
  init: "/api/user/init",
  his_url: "/api/message/list",
  chat_users_url: "/api/user/chatUserList",
  back_message_url:"/api/message/revoke",
  message_rows_url: "/api/message/getMsgRow",
  user_is_online:"/api/message/ifOnline",
  token_path: "/oauth/token",
  register_url: "/register",
  ws_protocol: "wss",
  // ws_host: "192.168.31.242",
  // ws_host:"im.auto-fam.com",
  ws_host:'im.auto-fam.com',
  getHostUrl: function() {
    return (
      this.http_protocol +
      "://" +
      (localStorage.getItem("host") || this.ws_host) +
      ":" +
      this.http_port
    );
  },
  getTokenUrl: function() {
    return this.getHostUrl() + this.token_path;
  },
  getInitUrl: function() {
    return this.getHostUrl() + this.init;
  },
  getChatUsersUrl: function() {
    return this.getHostUrl() + this.chat_users_url;
  },
  getHisUrl: function() {
    return this.getHostUrl() + this.his_url;
  },
  getMessageRows:function() {
      return this.getHostUrl() + this.message_rows_url;
  },
  getUserIsOnline:function() {
    return this.getHostUrl() + this.user_is_online;
  },
  getBackUrl:function() {
      return this.getHostUrl() + this.back_message_url;
  },
  getRegisterUrl: function() {
    return this.getHostUrl() + this.register_url;
  },
  getWsUrl: function() {
    return (
      this.ws_protocol +
      "://" +
      (localStorage.getItem("host") || this.ws_host) +
      ":" +
      this.ws_port
    );
  }
};
